export const INSURANCE_AUTH_KEY = 'INSURANCE_AUTH_KEY';
export const INSURANCE_AUTO_AUTH_KEY = 'INSURANCE_AUTO_AUTH_KEY';
export const USER_INFO = 'USER_INFO';
export const AUTH_INTEGRATION = 'AUTH_INTEGRATION_INFO';
export const CONTRACT_STORE_CODE = 'CONTRACT_STORE';
export const ANONYMOUS_USER = 'ANONYMOUS_USER';
